export default __webpack_public_path__ + "static/media/logo_volli.1c542f01.png";